__turbopack_context__.v({
  "bar": "HamburgerMorphIcon-module__sAIVsq__bar",
  "bottom": "HamburgerMorphIcon-module__sAIVsq__bottom",
  "open": "HamburgerMorphIcon-module__sAIVsq__open",
  "top": "HamburgerMorphIcon-module__sAIVsq__top",
});
